import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { FormValues } from './types/sourceDetailFormValues';
import {
  usePropertyListForSourceEditorQuery,
  Core,
  Bng,
  Hmm,
  Conductor,
} from '../../../types/generated-types';

import { calculateSourceFormValues } from './helpers/sourcesUtils';
import './shared/source-page.css';

export const SourceDetailViewer = ({
  source,
}: {
  source?: Partial<Core | Bng | Hmm | Conductor>;
}) => {
  const { data: propertyData } = usePropertyListForSourceEditorQuery();

  const initialValues: FormValues = calculateSourceFormValues(source);

  return (
    <Container
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box id="sourceId" className="view-only-box">
        <span style={{ marginRight: '6px' }}>Source ID:</span>
        <span id="sourceId" style={{ color: 'gray' }}>
          {source?._id}
        </span>
      </Box>
      <Box id="sourceId" className="view-only-box">
        <span style={{ marginRight: '6px' }}>Name:</span>
        <span id="name" style={{ color: 'gray' }}>
          {initialValues.name}
        </span>
      </Box>
      <Box id="sourceId" className="view-only-box">
        {propertyData?.properties && (
          <Box>
            <span style={{ marginRight: '6px' }}>Property:</span>
            <span id="propertyId" style={{ color: 'gray' }}>
              {propertyData.properties.map((property, index) => (
                <span key={index}>
                  {property._id === initialValues.propertyId && property.title}
                </span>
              ))}
            </span>
          </Box>
        )}
      </Box>
      <Box id="type" className="view-only-box">
        <span style={{ marginRight: '6px' }}>Type:</span>
        <span style={{ color: 'gray' }}>{initialValues.type}</span>
      </Box>
      <Box id="url" className="view-only-box">
        <span style={{ marginRight: '6px' }}>URL:</span>
        <span style={{ color: 'gray', lineBreak: 'anywhere' }}>
          {initialValues.url || initialValues.localUrl}
        </span>
      </Box>
      <Box id="maxReportingTime" className="view-only-box">
        <span style={{ marginRight: '6px' }}>Max Reporting Time:</span>
        <span style={{ color: 'gray' }}>{initialValues.maxReportingTime}</span>
      </Box>

      <Box id="tolerances" className="view-only-box">
        <span style={{ marginRight: '6px' }}>Measurement Tolerance:</span>
        <Typography sx={{ marginLeft: '1rem', color: 'gray' }}>
          Temperature (C): {initialValues.temperature}
        </Typography>
        <Typography sx={{ marginLeft: '1rem', color: 'gray' }}>
          Humidity (%): {initialValues.humidity}
        </Typography>
        <Typography sx={{ marginLeft: '1rem', color: 'gray' }}>
          Voltage (V):{initialValues.voltage}
        </Typography>
      </Box>
    </Container>
  );
};
